import { FC } from 'react';

import { IconButton } from '@mui/material';

import { ReactComponent as PlusIcon } from 'assets/icons/PlusIcon.svg';

import { IButtonCreateProjectProps } from '../../types';

import styles from './CreateProjectButtonFixed.module.scss';

export const CreateProjectButtonFixed: FC<IButtonCreateProjectProps> = ({ onClick, disabled }) => {
  return (
    <IconButton className={styles.createProjectButton} color='primary' onClick={onClick} disabled={disabled}>
      <PlusIcon />
    </IconButton>
  );
};
